import React from "react";
import GitHubIcon from "@material-ui/icons/GitHub";
import LaunchIcon from "@material-ui/icons/Launch";
import { Fade } from "react-reveal";

const featuredHighlights = [
  "Built an end-to-end RAG platform covering document ingestion, heading-aware chunking, embeddings, vector retrieval, and source-cited answers, using Azure Functions, Node.js, Azure OpenAI, Pinecone, and Azure SQL.",
  "Isolated tenants with workspace-scoped Pinecone namespaces, metadata filters, and Azure SQL access controls.",
  "Added batch embeddings, exponential backoff with jitter, and event-driven processing on Azure Service Bus, deployed through Azure DevOps CI/CD.",
  "Integrated Microsoft Entra ID authentication with MSAL, and used Microsoft Graph to ingest SharePoint documents into the RAG pipeline.",
  "Built ingestion for PDF, Word, and Excel files and web pages, with source files stored in Azure Blob Storage. Answers cite the exact source page.",
];

const earlierProjects = [
  {
    title: "SocialFly",
    skills: "React.js, Redux, Firebase",
    github: "https://github.com/dp789/socialfly",
    external: "http://social-fly.herokuapp.com/",
  },
  {
    title: "Chitrahaar",
    skills: "React.js, YouTube API, Firebase",
    github: "https://github.com/dp789/Yutube",
    external: "https://chitrahaar.netlify.app/",
  },
  {
    title: "BurgerCave",
    skills: "React.js, Redux, Firebase",
    github: "https://github.com/dp789/burger-app",
    external: "https://burger-cave.netlify.app/",
  },
  {
    title: "BookingMachine",
    skills: "React.js, Bootstrap",
    github: "https://github.com/dp789/booking-machine",
    external: "https://booking-machine.netlify.app/",
  },
  {
    title: "WeChat",
    skills: "React.js, Material UI, Firebase",
    github: "https://github.com/dp789/wechat",
    external: "https://lets-chat-together.netlify.app/",
  },
];

const Projects = () => {
  return (
    <div
      style={{ background: "#0b0b0d", color: "white" }}
      className="main-div"
      id="project"
    >
      <Fade left cascade>
        <section className="div-1">
          <h1 className="heading">Featured Project</h1>
          <article className="featured-project">
            <p className="eyebrow">GenAI</p>
            <h2>Research Hyper Agentic Assistant</h2>
            <p className="featured-summary">
              Multi-tenant RAG platform for document ingestion, vector
              retrieval, and source-cited answers.
            </p>
            <p className="featured-stack">
              Azure OpenAI, Pinecone, Azure Functions, Python, Node.js, React.js
            </p>
            <ul className="featured-highlights">
              {featuredHighlights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>

          <h2 className="earlier-heading">Earlier work</h2>
          <div className="compact-row">
            {earlierProjects.map((project) => (
              <article className="compact-card" key={project.title}>
                <h3>{project.title}</h3>
                <p>{project.skills}</p>
                <div className="compact-links">
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${project.title} on GitHub`}
                  >
                    <GitHubIcon />
                  </a>
                  <a
                    href={project.external}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${project.title} live site`}
                  >
                    <LaunchIcon />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </section>
      </Fade>
    </div>
  );
};

export default Projects;
